<h1>View for all components</h1>
<div class="row space-between w100" style="gap: 2rem">
  <div class="col w100">
    <h1>Headlines & Co</h1>
    <h1>H1 Headline</h1>
    <h2>H2 Headline</h2>
    <h3>H3 Headline</h3>
    <h4>H4 Headline</h4>
    <span
      >Simple Text. Lorem ipsum dolor sit amet, consectetur adipiscing elit
      placerat libero. Lorem ipsum dolor sit amet, consectetur adipiscing elit
      placerat libero. Lorem ipsum dolor sit amet, consectetur adipiscing elit
      placerat libero.</span
    >
    Divider
    <rr-divider></rr-divider>
    Tiny Text
    <span class="tiny">
      Simple Text. Lorem ipsum dolor sit amet, consectetur adipiscing elit
      placerat libero. Lorem ipsum dolor sit amet, consectetur adipiscing elit
      placerat libero. Lorem ipsum dolor sit amet, consectetur adipiscing elit
      placerat libero.
    </span>
  </div>
  <div class="col w100">
    <h1>Buttons</h1>
    <h2>Buttons - Medium</h2>
    <span>Btn - Default - Medium</span>
    <rr-btn iconStart="arrow-down" iconEnd="chevron-down">Save</rr-btn>
    <span>Btn - Primary - Medium</span>
    <rr-btn iconStart="ai" type="Primary" iconEnd="component">Save</rr-btn>
    <span>Btn - Secondary - Medium</span>
    <rr-btn iconStart="ai" iconEnd="component" type="Secondary">Cancel</rr-btn>
    <span>Btn - Tertiary - Medium</span>
    <rr-btn iconStart="ai" iconEnd="component" type="Tertiary">Cancel</rr-btn>
    <span>Btn - Primary - Medium -Disabled</span>
    <rr-btn iconStart="ai" iconEnd="component" type="Primary">Cancel</rr-btn>
    <h2>Buttons - Small</h2>
    <span>Btn - Default - Small</span>
    <rr-btn iconStart="filter" size="small">Optimize</rr-btn>
    <span>Btn - Primary - Small</span>
    <rr-btn iconStart="ai" iconEnd="component" size="small" type="Primary"
      >Optimize</rr-btn
    >
    <span>Btn - Secondary - Small</span>
    <rr-btn iconStart="ai" iconEnd="component" type="Secondary" size="small"
      >Optimize</rr-btn
    >
    <span>Btn - Tertiary - Small</span>
    <rr-btn iconStart="ai" iconEnd="component" type="Tertiary" size="small"
      >Optimize</rr-btn
    >
    <span>Btn - Primary - Small - Disabled</span>
    <rr-btn
      iconStart="ai"
      iconEnd="component"
      type="primary"
      size="small"
      [disabled]="true"
      >Optimize</rr-btn
    >
    <h2>Action & Link Button</h2>
    <span>Btn - Action</span>
    <div class="row">
      <rr-btn iconStart="trash" type="Action"></rr-btn>
      <rr-btn iconStart="more" type="Action"></rr-btn>
    </div>
    <span>Btn - Link</span>
    <rr-btn type="Link" iconStart="arrow-left" iconEnd="component">Back</rr-btn>
  </div>
</div>
<div class="row w100">
  <div class="col w100">
    <h2>Checkboxen</h2>
    <span>Checkbox - Medium</span>
    <rr-checkbox>Some text</rr-checkbox>
    <span>Checkbox - Medium - checked</span>
    <rr-checkbox [checked]="true">Some text</rr-checkbox>
    <span>Checkbox - Medium - Indeterminate</span>
    <rr-checkbox [indeterminate]="true">Some text</rr-checkbox>
    <span>Checkbox - Small</span>
    <rr-checkbox size="small">Some text</rr-checkbox>
    <span>Checkbox - Small - Indeterminate</span>
    <rr-checkbox [indeterminate]="true" size="small">Some text</rr-checkbox>
    <span>Checkbox - Medium - Disabled</span>
    <rr-checkbox [disabled]="true">Some text</rr-checkbox>
    <span>Checkbox - Small - Disabled - Checked</span>
    <rr-checkbox size="small" [checked]="true" [disabled]="true"
      >Some text</rr-checkbox
    >
    <span>Checkbox - Small - Disabled - Indeterminate</span>
    <rr-checkbox size="small" [indeterminate]="true" [disabled]="true"
      >Some text</rr-checkbox
    >
  </div>
  <div class="col w100">
    <h2>Input's</h2>
    <rr-input label="Just Input"></rr-input>
    <rr-input label="Input - Placeholder" placeholder="Placeholder"></rr-input>
    <rr-input
      label="Input - Placeholder - Required"
      placeholder="Email"
      type="email"
      class="focus"
      [required]="true"
    ></rr-input>
    <rr-input
      label="Input - Date - Required"
      placeholder="Date"
      type="date"
      [required]="true"
    ></rr-input>
    <rr-input
      label="Input - Number - Required"
      placeholder="Number"
      type="number"
      [required]="true"
    ></rr-input>
    <rr-input label="Input - URL" placeholder="URL" type="url"></rr-input>
  </div>
</div>

<div class="row w100">
  <div class="col w100">
    <rr-icon name="user"></rr-icon>
    <h2>Badge's</h2>
    <span>Badge - Medium - Neutral</span>
    <rr-badge icon="component" size="medium" tone="neutral">Label</rr-badge>
    <span>Badge - Medium - Error</span>
    <rr-badge icon="error" size="medium" tone="error">Label</rr-badge>
    <span>Badge - Medium - Warning</span>
    <rr-badge icon="alert" size="medium" tone="warning">Label</rr-badge>
    <span>Badge - Small - Success</span>
    <rr-badge icon="check-circle" tone="success">Label</rr-badge>
    <span>Badge - Small - Information</span>
    <rr-badge icon="info" tone="information">Label</rr-badge>
    <span>Badge - Small - Brand</span>
    <rr-badge icon="ai" tone="brand">Label</rr-badge>
    <span>Badge - Small - Neutral - No Icon</span>
    <rr-badge tone="neutral" property="no-icon">Label</rr-badge>
    <span>Badge - Small - Badge Dot</span>
    <rr-badge>Label</rr-badge>
  </div>
</div>
<div class="row">
  <div class="col">
    <h1>Icons</h1>
    <div class="row gap-8">
      <rr-icon name="ai"></rr-icon>
      <rr-icon name="octagon"></rr-icon>
      <rr-icon name="component"></rr-icon>
      <rr-icon name="arrow-left"></rr-icon>
      <rr-icon name="search"></rr-icon>
      <rr-icon name="filter"></rr-icon>
      <rr-icon name="arrow-down"></rr-icon>
      <rr-icon name="chevron-down"></rr-icon>
      <rr-icon name="mic"></rr-icon>
      <rr-icon name="wind"></rr-icon>
      <rr-icon name="edit"></rr-icon>
      <rr-icon name="more"></rr-icon>
      <rr-icon name="layout"></rr-icon>
      <rr-icon name="alert"></rr-icon>
      <rr-icon name="trash"></rr-icon>
      <rr-icon name="user"></rr-icon>
      <rr-icon name="logout"></rr-icon>
      <rr-icon name="heart"></rr-icon>
      <rr-icon name="file"></rr-icon>
      <rr-icon name="close"></rr-icon>
      <rr-icon name="error"></rr-icon>
      <rr-icon name="settings"></rr-icon>
      <rr-icon name="box"></rr-icon>
      <rr-icon name="add"></rr-icon>
      <rr-icon name="info"></rr-icon>
      <rr-icon name="check"></rr-icon>
      <rr-icon name="check_circle"></rr-icon>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <h1>Segment Control</h1>
    <span>Segment Control - Medium - without icons</span>
    <rr-segment-control>
      <rr-segment-control-item name="Label"></rr-segment-control-item>
      <rr-segment-control-item name="Label"></rr-segment-control-item>
      <rr-segment-control-item name="Label"></rr-segment-control-item>
    </rr-segment-control>
    <span>Segment Control - Medium - with icons</span>
    <rr-segment-control>
      <rr-segment-control-item name="Label" icon="component"></rr-segment-control-item>
      <rr-segment-control-item name="Label" icon="component"></rr-segment-control-item>
      <rr-segment-control-item name="Label" icon="component"></rr-segment-control-item>
      <rr-segment-control-item name="Label" icon="component"></rr-segment-control-item>
    </rr-segment-control>
    <span>Segment Control - Small - without icons</span>
    <rr-segment-control size="small">
      <rr-segment-control-item name="Unfinished"></rr-segment-control-item>
      <rr-segment-control-item name="Finished"></rr-segment-control-item>
      <rr-segment-control-item name="All"></rr-segment-control-item>
    </rr-segment-control>
    <span>Segment Control - Small - with icons</span>
    <rr-segment-control size="small">
      <rr-segment-control-item name="Inbox" icon="file"></rr-segment-control-item>
      <rr-segment-control-item name="Liked" icon="heart"></rr-segment-control-item>
      <rr-segment-control-item name="Removed" icon="trash"></rr-segment-control-item>
      <rr-segment-control-item name="Rejected" icon="octagon"></rr-segment-control-item>
      <rr-segment-control-item name="More" icon="more"></rr-segment-control-item>
    </rr-segment-control>
  <div class="col w100">
    <rr-tab-control>
      <rr-tab step="1" label="Basic Settings">
        <h2>Test Tab content</h2>
      </rr-tab>
      <rr-tab step="2" label="License & Seats">
        <h2>Test Tab content 2</h2>
      </rr-tab>
    </rr-tab-control>
  </div>
</div>
<div class="row">
  <div class="col">
    <h1>Range Control</h1>
    <span>Range Control - icon - startPosition middle (default)</span>
    <rr-range-control label="Desireability" leftLabel="Less" rightLabel="More" icon="heart"></rr-range-control>
    <span>Range Control - startPosition left</span>
    <rr-range-control label="Range Control" leftLabel="0" rightLabel="100" startPosition="left"></rr-range-control>
  </div>
</div>